module.exports = __webpack_public_path__ + "assets/img/33_163.3628fb45.jpg";